"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Container_1 = require("./Container");
var shortcuts_1 = require("./shortcuts");
var Text_1 = require("./Text");
var Typography = (function (_super) {
    __extends(Typography, _super);
    function Typography() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Typography.Text = Text_1.default;
    Typography.Body1 = shortcuts_1.Body1;
    Typography.Body2 = shortcuts_1.Body2;
    Typography.Caption = shortcuts_1.Caption;
    Typography.Display1 = shortcuts_1.Display1;
    Typography.Display2 = shortcuts_1.Display2;
    Typography.Display3 = shortcuts_1.Display3;
    Typography.Display4 = shortcuts_1.Display4;
    Typography.Headline = shortcuts_1.Headline;
    Typography.Subheading1 = shortcuts_1.Subheading1;
    Typography.Subheading2 = shortcuts_1.Subheading2;
    Typography.Title = shortcuts_1.Title;
    return Typography;
}(Container_1.default));
exports.default = Typography;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/typography/lib/index.js
// module id = ./node_modules/@react-mdc/typography/lib/index.js
// module chunks = 1 2 3